export default function Contact() {
  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-red-600 text-sm font-semibold uppercase tracking-widest mb-4">
            <span className="w-8 h-0.5 bg-red-600 inline-block"></span>
            İletişim
            <span className="w-8 h-0.5 bg-red-600 inline-block"></span>
          </div>
          <h2 className="text-4xl font-black text-gray-900 mb-4">
            Teklif Almak İçin <br />
            <span className="text-red-600">Bize Ulaşın</span>
          </h2>
          <p className="text-gray-600 text-base leading-relaxed max-w-xl mx-auto">
            Lightbox projeniz için hemen arayın veya WhatsApp üzerinden mesaj gönderin.
            Uzman ekibimiz size en kısa sürede dönüş yapacaktır.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-stretch max-w-3xl mx-auto">
          {/* Hemen Ara */}
          <a
            href="tel:+905362771709"
            className="w-full sm:w-auto flex-1 flex items-center justify-center gap-4 bg-red-600 hover:bg-red-700 text-white rounded-2xl px-8 py-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl group"
          >
            <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-xl flex-shrink-0 group-hover:bg-white/30 transition-colors">
              <i className="ri-phone-line text-3xl"></i>
            </div>
            <div className="text-left">
              <h3 className="text-white text-xs font-semibold uppercase tracking-widest mb-1">Hemen Ara</h3>
              <div className="text-white font-black text-xl">+90 (536) 277 17 09</div>
              <div className="text-white text-xs mt-0.5">Pzt – Cmt: 08:00 – 18:00</div>
            </div>
          </a>

          {/* WhatsApp ile İletişim */}
          <a
            href="https://wa.me/905362771709?text=Merhaba%2C%20lightbox%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto flex-1 flex items-center justify-center gap-4 bg-[#25D366] hover:bg-[#1ebe5d] text-white rounded-2xl px-8 py-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl group"
          >
            <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-xl flex-shrink-0 group-hover:bg-white/30 transition-colors">
              <i className="ri-whatsapp-line text-3xl"></i>
            </div>
            <div className="text-left">
              <h3 className="text-white text-xs font-semibold uppercase tracking-widest mb-1">WhatsApp ile İletişim</h3>
              <div className="text-white font-black text-xl">+90 (536) 277 17 09</div>
              <div className="text-white text-xs mt-0.5">7/24 mesaj gönderebilirsiniz</div>
            </div>
          </a>

          {/* Keşif ve Ölçülendirme */}
          <a
            href="https://wa.me/905362771709?text=Merhaba%2C%20ke%C5%9Fif%20ve%20%C3%B6l%C3%A7%C3%BClendirme%20talebi%20i%C3%A7in%20ula%C5%9F%C4%B1yorum."
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto flex-1 flex items-center justify-center gap-4 bg-gray-800 hover:bg-gray-900 text-white rounded-2xl px-8 py-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl group"
          >
            <div className="w-14 h-14 flex items-center justify-center bg-white/10 rounded-xl flex-shrink-0 group-hover:bg-white/20 transition-colors">
              <i className="ri-map-pin-line text-3xl"></i>
            </div>
            <div className="text-left">
              <h3 className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-1">Keşif ve Ölçülendirme Talebi</h3>
              <div className="text-white font-black text-base leading-tight">Ücretsiz Keşif</div>
              <div className="text-gray-400 text-xs mt-0.5">İzmir ve çevre illerde ücretsiz</div>
            </div>
          </a>
        </div>

        {/* Alt bilgi */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-10 text-sm text-gray-500">
          <span className="flex items-center gap-2">
            <i className="ri-mail-line text-red-500"></i>
            atatente@hotmail.com
          </span>
          <span className="hidden sm:block w-1 h-1 bg-gray-300 rounded-full"></span>
          <span className="flex items-center gap-2">
            <i className="ri-map-pin-line text-red-500"></i>
            Yeşillik Cad. 5757 Sok. No:22/C Karabağlar / İzmir
          </span>
        </div>
      </div>
    </section>
  );
}
